/**
 * Generated by orval 🍺
 * Do not edit manually.
 * PF Appointments API
 * appointments-api v1. Generated from the route table; do not edit by hand (pnpm openapi).
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod'

export const adminHealthPageItemsItemClinicIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
)
export const adminHealthPageItemsItemOverallDaysItemDateRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}$')
export const adminHealthPageItemsItemOverallUptimeOneMin = 0
export const adminHealthPageItemsItemOverallUptimeOneMax = 1

export const adminHealthPageItemsItemPfLastHeartbeatAtOneRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
)
export const adminHealthPagePageMax = 9007199254740991

export const adminHealthPagePageSizeMax = 100

export const adminHealthPageTotalMin = 0
export const adminHealthPageTotalMax = 9007199254740991

export const AdminHealthPage = zod.object({
  items: zod.array(
    zod.object({
      clinic: zod.object({
        id: zod.uuid().regex(adminHealthPageItemsItemClinicIdRegExp),
        name: zod.string(),
        slug: zod.string(),
        status: zod.enum(['active', 'inactive']),
      }),
      components: zod.array(
        zod.object({
          component: zod.enum(['pf_keeper_app', 'pf_session']),
          state: zod.enum(['up', 'degraded', 'down', 'unknown']),
        }),
      ),
      needsAttention: zod.boolean(),
      overall: zod.object({
        days: zod.array(
          zod.object({
            date: zod.string().regex(adminHealthPageItemsItemOverallDaysItemDateRegExp),
            level: zod.enum(['ok', 'minor', 'major', 'no_data']),
          }),
        ),
        uptime: zod.union([
          zod
            .number()
            .min(adminHealthPageItemsItemOverallUptimeOneMin)
            .max(adminHealthPageItemsItemOverallUptimeOneMax),
          zod.null(),
        ]),
      }),
      pf: zod.object({
        degradedReason: zod.string().nullable(),
        lastHeartbeatAt: zod.union([
          zod.iso.datetime({ offset: true }).regex(adminHealthPageItemsItemPfLastHeartbeatAtOneRegExp),
          zod.null(),
        ]),
        pfKeeperApp: zod.enum(['up', 'degraded', 'down', 'unknown']),
        pfSession: zod.enum(['up', 'degraded', 'down', 'unknown']),
        status: zod.enum(['healthy', 'degraded', 'down', 'unknown', 'not_connected', 'inactive']),
      }),
    }),
  ),
  page: zod.int().min(1).max(adminHealthPagePageMax),
  pageSize: zod.int().min(1).max(adminHealthPagePageSizeMax),
  total: zod.int().min(adminHealthPageTotalMin).max(adminHealthPageTotalMax),
})

export type AdminHealthPage = zod.input<typeof AdminHealthPage>
export type AdminHealthPageOutput = zod.output<typeof AdminHealthPage>
